import {
  Box,
  Button,
  Flex,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import PropTypes from 'prop-types';
import DealIrrModelEditInputs from './DealIrrModelEditInputs';
import DealIrrModelInputsPanel from './DealIrrModelInputsPanel';
import DealIrrModelTable from './DealIrrModelTable';
import { resolveCogsDecimal } from './calc/resolveDealIrrModelInputs';

function DealIrrModelOverlay({
  isOpen,
  onClose,
  state,
  setState,
  planMonths,
  useHillRoas,
  dealIrrModel,
  facilityFeeAmount,
  facilityFeeInstallmentCount,
  hillModel,
}) {
  const defaultRevenueSharePct =
    state.revenueShareForRepaymentPct ??
    Math.round(resolveCogsDecimal(state.gpm) * 10000) / 100;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full" scrollBehavior="inside">
      <ModalOverlay bg="blackAlpha.700" />
      <ModalContent maxW="100vw" m={0} borderRadius={0} minH="100vh">
        <ModalHeader
          borderBottom="1px solid"
          borderColor="gray.200"
          py={2}
          px={4}
          position="sticky"
          top={0}
          bg="white"
          zIndex={2}
        >
          <Flex align="center" justify="space-between" gap={3}>
            <Text fontWeight="semibold" fontSize="md">
              Edit pricing model
            </Text>
            <Flex align="center" gap={2}>
              <Button size="sm" colorScheme="purple" onClick={onClose}>
                Done
              </Button>
              <IconButton
                aria-label="Close"
                icon={<CloseIcon />}
                size="sm"
                variant="ghost"
                onClick={onClose}
              />
            </Flex>
          </Flex>
        </ModalHeader>
        <ModalBody p={0} bg="gray.50" className="deal-irr-overlay-body">
          <Flex className="deal-irr-overlay-panels">
            <Box className="deal-irr-panel deal-irr-panel--inputs deal-irr-panel--compact deal-irr-overlay-inputs">
              <Text className="deal-irr-panel-title">Input</Text>
              <DealIrrModelEditInputs
                state={state}
                setState={setState}
                planMonths={planMonths}
                facilityFeeInstallmentCount={facilityFeeInstallmentCount}
                defaultRevenueSharePct={defaultRevenueSharePct}
                useHillRoas={useHillRoas}
                hillModel={hillModel}
              />
            </Box>
            <Box className="deal-irr-overlay-calculated">
              <DealIrrModelInputsPanel
                state={state}
                outputs={dealIrrModel?.outputs ?? {}}
                facilityFeeAmount={facilityFeeAmount}
                variant="calculated"
              />
            </Box>
          </Flex>

          <Box className="deal-irr-overlay-table">
            <DealIrrModelTable
              model={dealIrrModel}
              useHillRoas={useHillRoas}
              editMode
              state={state}
              setState={setState}
            />
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

DealIrrModelOverlay.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  state: PropTypes.object.isRequired,
  setState: PropTypes.func.isRequired,
  planMonths: PropTypes.array.isRequired,
  useHillRoas: PropTypes.bool,
  dealIrrModel: PropTypes.object,
  facilityFeeAmount: PropTypes.number.isRequired,
  facilityFeeInstallmentCount: PropTypes.number.isRequired,
  hillModel: PropTypes.object,
};

export default DealIrrModelOverlay;
